import React, { useEffect, useState } from "react";
import $ from "jquery";

import { HeroSm, NavBar, Spinner } from "../components";
import { Footer } from "../layouts";
import { useSelector } from "react-redux";
import { store } from "../store";
import { Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";

const CategoryList = () => {
  const [loadPage, setLoadPage] = useState(true);
  // const [spinColor, setSpinColor] = useState("success");
  const [categoryTitle, setCategoryTitle] = useState("ABN | Categorie");

  useEffect(() => {
    let tim2 = setTimeout(() => {
      setLoadPage(false);
    }, 1000);

    return () => {
      clearTimeout(tim2);
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner grow color={"success"} size={5} />
          </div>
        </>
      ) : (
        <Main setCategoryTitle={setCategoryTitle} />
      )}

      <Helmet>
        <title>{categoryTitle}</title>
        <link
          rel="stylesheet"
          href="../assets/css/bootstrap/icons/bootstrap-icons.css"
        />
        <link
          rel="stylesheet"
          href="../assets/css/hs/mega-menu/mega-menu.min.css"
        />
        <link rel="stylesheet" href="../assets/css/_theme.css" />

        <script
          defer
          asyn
          src="../assets/js/bootstrap/bootstrap.bundle.min.js"
        ></script>
        <script defer asyn src="../assets/js/hs/go-to/goto.min.js"></script>
        <script defer asyn src="../assets/js/prism/prism.js"></script>
        <script
          defer
          asyn
          src="../assets/js/hs/show-animation/show-animation.min.js"
        ></script>
        <script
          defer
          asyn
          src="../assets/js/hs/mega-menu/mega-menu.min.js"
        ></script>
        <script defer asyn src="../assets/js/hs/header/header.min.js"></script>
        <script defer asyn src="../assets/js/fslightbox/index.js"></script>
        <script defer asyn src="../assets/js/theme.min.js"></script>
      </Helmet>
    </>
  );
};

export default CategoryList;

const Main = ({ setCategoryTitle }) => {
  let categories = useSelector((x) => x.auth.categories);
  const [category, setCategory] = useState("");
  const [companies, setCompanies] = useState(null);
  const [subCategories, setSubCategories] = useState(null);
  const categoryId = category ? category.id : null;

  useEffect(() => {
    let tim1 = setInterval(() => {
      let path = atob(window.location.pathname.split("/")[2]);

      categories = store.getState().auth.categories;
      setCategory(categories.find((category) => category.link === path));
      setCategoryTitle(
        categories.find((category) => category.link === path).name
      );
    }, 200);

    const fetchCompanies = async () => {
      try {
        const response = await axios.get(
          `https://abn.happynessarl.com/api/v1/company/${categoryId}`
        );
        const data = response.data;
        setCompanies(data);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    const fetchsubCategories = async () => {
      try {
        const response = await axios.get(
          `https://abn.happynessarl.com/api/v1/get-sub-by-category-id/${categoryId}`
        );
        const data = response.data;
        setSubCategories(data);
      } catch (error) {
        console.error("Error fetching sub categories:", error);
      }
    };

    if (category) {
      fetchCompanies();
      fetchsubCategories();
    }

    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      clearInterval(tim1);

      $(".homescript").remove();
    };
  }, [category, categoryId, setCategoryTitle]);

  return (
    <>
      <NavBar sub />
      <HeroSm sub={category} title={category.name} />
      <main id="content" role="main">
        <div className="container content-space-t-1 content-space-b-2 content-space-b-lg-3">
          <div className="mb-5">
            <div className="row">
              {subCategories === null ? (
                <div className="container text-center my-4">
                  <Spinner grow={false} color={"success"} size={3} />
                </div>
              ) : (
                <>
                  <div className="col-sm col-11 mb-3 mb-sm-0 border rounded p-3 ms-2">
                    <h3 className="mb-3 mt-3">Refine your search</h3>
                    <div className="d-flex flex-wrap">
                      {subCategories.data.length === 0 ? (
                        <p>No sub category found.</p>
                      ) : (
                        subCategories.data.length > 0 && (
                          <>
                            {subCategories.data.map((subCategory) => (
                              <div key={subCategory.id} className="w-50 my-2">
                                <Link
                                  to={`/category-details/${btoa(
                                    subCategory.id
                                  )}`}
                                >
                                  {subCategory.name}
                                </Link>
                              </div>
                            ))}
                          </>
                        )
                      )}
                    </div>
                  </div>

                  <div className="col-sm-auto">
                    <select className="form-select form-select-sm">
                      <option value="mostRecent" selected>
                        Most recent
                      </option>
                      <option value="HighestPrice">Highest price</option>
                      <option value="LowestPrice">Lowest price</option>
                      <option value="mostReduced">Most reduced</option>
                      <option value="mostPopular">Most popular</option>
                    </select>

                    <div className="mt-5">
                      <div className="border border-bottom-0 rounded-top px-5 pt-3 pb-2">
                        <h3>Associated companies</h3>
                      </div>
                      <div className="border rounded-bottom px-5 pt-3 pb-2">
                        {companies?.data.data?.length === 0 ? (
                          <p>No companies found.</p>
                        ) : (
                          companies?.data.data?.length > 0 && (
                            <ul>
                              {companies?.data.data.map((company) => (
                                <li key={company.id}>
                                  <div className="d-flex gap-2">
                                    <div>
                                      <h4>{company.name}</h4>
                                      <p>{company.pays}</p>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer sub />
    </>
  );
};
